/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_To_SettleInputs */

const en_queue_inbounds_to_settle = /** @type {(inputs: Queue_Inbounds_To_SettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing units to settle`)
};

/**
* | output |
* | --- |
* | "Missing units to settle" |
*
* @param {Queue_Inbounds_To_SettleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_to_settle = /** @type {((inputs?: Queue_Inbounds_To_SettleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_To_SettleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_to_settle(inputs)
});